import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

// Classic 4-group scheme (matches the standard amino acid chart)
// Order on X axis: grouped by category, alphabetical within each group
const AA_ORDER = [
  // Non-polar (hydrophobic)
  "ALA", "CYS", "GLY", "ILE", "LEU", "MET", "PHE", "PRO", "TRP", "VAL",
  // Polar (uncharged)
  "ASN", "GLN", "SER", "THR", "TYR",
  // Positive charge
  "ARG", "HIS", "LYS",
  // Negative charge
  "ASP", "GLU",
];

const AA_CATEGORY = {
  ALA: "Non-polar", CYS: "Non-polar", GLY: "Non-polar", ILE: "Non-polar",
  LEU: "Non-polar", MET: "Non-polar", PHE: "Non-polar", PRO: "Non-polar",
  TRP: "Non-polar", VAL: "Non-polar",
  ASN: "Polar", GLN: "Polar", SER: "Polar", THR: "Polar", TYR: "Polar",
  ARG: "Positive", HIS: "Positive", LYS: "Positive",
  ASP: "Negative", GLU: "Negative",
};


const CATEGORY_COLORS = {
  "Non-polar": "#f4d03f", // yellow
  "Polar":     "#5dade2", // blue
  "Positive":  "#58d68d", // green
  "Negative":  "#bb8fce", // purple
};

const CATEGORY_ORDER = ["Non-polar", "Polar", "Positive", "Negative"];

const AAFrequencyChart = ({ contactData }) => {
  const [plotData, setPlotData] = useState([]);
  const [layout, setLayout] = useState({});

  useEffect(() => {

    if (!Array.isArray(contactData) || contactData.length === 0) {
      setPlotData([]);
      return;
    }

    const counts = {};
    AA_ORDER.forEach((aa) => { counts[aa] = 0; }); // initialize all 20 to zero

    contactData.forEach(({ details }) => {
      if (!details) return;
      const parts = details.split('|');
      for (let i = 0; i < parts.length; i++) {
        const tokens = parts[i].trim().split('/');
        if (tokens.length >= 4) {
          const aa = tokens[3].trim().toUpperCase();
          if (aa in counts) counts[aa] += 1;
        }
      }
    });

    // One trace per category — Plotly draws automatic legend
    const traces = CATEGORY_ORDER.map((category) => {
      const yValues = AA_ORDER.map((aa) =>
        AA_CATEGORY[aa] === category ? counts[aa] : null
      );

      return {
        x: AA_ORDER,
        y: yValues,
        name: category,
        type: "bar",
        hovertemplate: `Residue: %{x}<br>Count: %{y}<br>Category: ${category}<extra></extra>`,
        marker: {
          color: CATEGORY_COLORS[category],
          line: { color: "#333", width: 0.5 },
        },
      };
    });

    setPlotData(traces);

    setLayout({
      autosize: true,
       font: { size: 9 },
      title: { text: "Amino Acid Frequency in Contacts" },
      xaxis: {
        type: "category",
        categoryorder: "array",
        categoryarray: AA_ORDER,
        title: { text: "Amino acid" },
        tickangle: -45,
      },
      yaxis: {
        title: { text: "# of occurrences" },
      },
      barmode: "overlay",
      showlegend: true,
      legend: {
        title: { text: "Category" },
        orientation: "v",
        x: 1.02,
        y: 1,
      },
      margin: { t: 50, b: 80, l: 60, r: 80 },
    });
  }, [contactData]);

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default AAFrequencyChart;
